// Where a job's loom speed or weaving efficiency came from. Mirrors
// TMSWeb.Common.Constants.LoomRateSources - the production plan shows it beside the run time.
export enum LoomRateSources {
  colourway = 'Colourway',
  quality = 'Quality',
  loom = 'Loom',
  // A job on no loom yet is estimated on the looms' average speed.
  averageLoom = 'AverageLoom',
  notSet = 'NotSet',
}
